<div
  class="app-top-nav-content"
  fxLayout="row nowrap"
  fxLayoutAlign="space-between stretch"
  fxLayoutGap="10px"
>
  <div fxLayout="row nowrap" fxLayoutAlign="start center" fxLayoutGap="10px">
    <button mat-icon-button class="menu-btn" (click)="clickEvent.emit()">
      <mat-icon>menu</mat-icon>
    </button>
    <img [src]="logo ?? 'assets/image/logo/provider.png'" alt="" srcset="" />
  </div>
  <div class="right-box">
    <div class="display-date">
      {{ dateNow$ | async | date: "MMM d, yyyy, h:mm:ss a" }}
    </div>
    <div class="divider-line"></div>
    <div (click)="onToggleFullscreen()" class="fullscreen-btn">
      <mat-icon style="color: var(--third-color)">
        {{ isFullScreenNow ? "zoom_in_map" : "zoom_out_map" }}
      </mat-icon>
    </div>
    <div
      class="current-module-display"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <img [src]="currentModuleIcon" class="mini-icon" />
      <span class="module-label">{{ currentModuleLabel }}</span>
    </div>
    <div class="fullscreen-btn" [matMenuTriggerFor]="moduleMenu">
      <mat-icon style="color: var(--third-color)"> widgets </mat-icon>
    </div>
    <mat-menu #moduleMenu="matMenu" class="module-launcher-menu">
      <div class="favorite-section" *ngIf="favoriteModulesData.length > 0">
        <div class="section-title">{{ "view_value.favorite" | translate }}</div>
        <div class="module-grid">
          <div
            class="module-item"
            *ngFor="let fav of favoriteModulesData"
            (click)="onModuleClick(fav)"
            [class.active]="fav.label === currentModuleLabel"
          >
            <mat-icon
              class="fav-star"
              [class.is-fav]="favoriteList.includes(fav.label)"
              (click)="toggleFavorite($event, fav.label)"
            >
              {{ favoriteList.includes(fav.label) ? "star" : "star_border" }}
            </mat-icon>
            <div class="icon-wrapper">
              <img [src]="fav.icon" [alt]="fav.label" />
            </div>
            <span class="label">
              {{ fav.label }}
            </span>
          </div>
        </div>
        <div class="horizontal-divider"></div>
      </div>
      <!-- <div class="section-title">{{ "โมดูลทั้งหมด" | translate }}</div> -->
      <div class="module-grid">
        <div
          class="module-item"
          *ngFor="let item of moduleMenus()"
          (click)="onModuleClick(item)"
          [class.active]="item.label === currentModuleLabel"
        >
          <mat-icon
            class="fav-star"
            [class.is-fav]="favoriteList.includes(item.label)"
            (click)="toggleFavorite($event, item.label)"
          >
            {{ favoriteList.includes(item.label) ? "star" : "star_border" }}
          </mat-icon>
          <div class="icon-wrapper">
            <img
              [src]="
                item.label === currentModuleLabel
                  ? item.icon
                    ? item.icon
                    : item.icon_active
                  : item.icon
              "
              [alt]="item.label"
            />
          </div>
          <span class="label">
            {{ item.label }}
          </span>
        </div>
      </div>
    </mat-menu>
    <div class="profile-section" [matMenuTriggerFor]="profileMenu">
      <div class="avatar-wrapper">
        <img
          *ngIf="displayAvatar"
          [src]="displayAvatar"
          [alt]="email"
          (error)="handleImageError()"
          class="avatar-img"
        />

        <div
          *ngIf="!displayAvatar"
          class="avatar-fallback"
          [style.background-color]="avatarBackgroundColor"
        >
          {{ avatarFallbackChar }}
        </div>
      </div>
    </div>
  </div>
</div>

<mat-menu #profileMenu="matMenu" class="profile-menu" panelClass="custom-menu">
  <div mat-menu-item class="profile-item profile-menu-item">
    <!-- <div class="avatar-wrapper">
      <img
        *ngIf="displayAvatar"
        [src]="displayAvatar"
        [alt]="email"
        (error)="handleImageError()"
        class="avatar-img"
      />
      <div
        *ngIf="!displayAvatar"
        class="avatar-fallback"
        [style.background-color]="avatarBackgroundColor"
      >
        {{ avatarFallbackChar }}
      </div>
    </div> -->
    <div class="profile-info">
      <div class="profile-name">{{ email }}</div>
      <div class="profile-role">{{ userRole }}</div>
    </div>
  </div>
  <div
    mat-menu-item
    [matMenuTriggerFor]="languageMenu"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10px"
  >
    <mat-icon>language</mat-icon>
    {{ selectedLanguageLabel }}
  </div>
  <div
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10px"
    (click)="logout()"
  >
    <mat-icon>logout</mat-icon>
    <span>{{ "view_value.log_out" | translate }}</span>
  </div>
</mat-menu>

<mat-menu #languageMenu="matMenu" class="profile-menu">
  <button
    mat-menu-item
    *ngFor="let language of Languages"
    (click)="onSelectLanguage(language.value)"
  >
    {{ language.viewValue }}
  </button>
</mat-menu>
